import { Recipe } from "./types";

export const initialRecipe: Recipe = {
  id: -1,
  title: "",
  metaDescription: "",
  cookingTime: "",
  metaTitle: "",
  numberOfPeople: 0,
  slug: "",
  content: "",
  ingredients: "",
  category: null,
  image: null,
  published: false,
  createdAt: new Date(),
  updatedAt: new Date(),
};
